export const COMMON_SELECTION_OPTIONS = [
  { id: "YES", type: "Yes" },
  { id: "NO", type: "No" },
  {
    id: "UNDISCLOSED",
    type: "Prefer not to mention",
  },
];

export const USER_SUBSCRIPTION_STATUS = Object.freeze({
  NOT_STARTED: "NOT_STARTED",
  STARTED: "STARTED",
  RENEWED: "RENEWED",
  GRACE_PERIOD: "GRACE_PERIOD",
  RENEW_FAILED: "RENEW_FAILED",
  USER_CANCELLED: "USER_CANCELLED",
  SYSTEM_CANCELLED: "SYSTEM_CANCELLED",
  ADMIN_CANCELLED: "ADMIN_CANCELLED",
});

export const SUBSCRIPTION_STATUS_INFO = [
  {
    id: USER_SUBSCRIPTION_STATUS.STARTED,
    labelName: "Subscription Active",
    labelType: "success",
  },
  {
    id: USER_SUBSCRIPTION_STATUS.RENEWED,
    labelName: "Subscription Renewed",
    labelType: "success",
  },
  {
    id: USER_SUBSCRIPTION_STATUS.GRACE_PERIOD,
    labelName: "Subscription in Grace Period",
    labelType: "alert",
  },
  {
    id: USER_SUBSCRIPTION_STATUS.RENEW_FAILED,
    labelName: "Subscription Renewal Failed",
    labelType: "alert",
  },
  {
    id: USER_SUBSCRIPTION_STATUS.USER_CANCELLED,
    labelName: "Subscription Cancelled by User",
    labelType: "alert",
  },
  {
    id: USER_SUBSCRIPTION_STATUS.SYSTEM_CANCELLED,
    labelName: "Subscription Cancelled by System",
    labelType: "alert",
  },
  {
    id: USER_SUBSCRIPTION_STATUS.ADMIN_CANCELLED,
    labelName: "Subscription Cancelled by Admin",
    labelType: "alert",
  },
];

export const USER_PROFILE_STATUS = Object.freeze({
  INCOMPLETE: "INCOMPLETE",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  IN_REVIEW: "IN_REVIEW",
  LIVE: "LIVE",
  EXPIRED: "EXPIRED",
  DISABLED: "DISABLED",
});

export const SUPPORTED_FILE_TYPE_CATEGORIES = Object.freeze({
  IMAGE: "IMAGE",
  PDF: "PDF",
});

export const SUPPORTED_MIME_TYPES = Object.freeze({
  JPEG: "image/jpeg",
  PNG: "image/png",
  PDF: "application/pdf",
});

export const MIME_TYPE_TO_CATEGORY_MAP = Object.freeze({
  [SUPPORTED_MIME_TYPES.JPEG]: SUPPORTED_FILE_TYPE_CATEGORIES.IMAGE,
  [SUPPORTED_MIME_TYPES.PNG]: SUPPORTED_FILE_TYPE_CATEGORIES.IMAGE,
  [SUPPORTED_MIME_TYPES.PDF]: SUPPORTED_FILE_TYPE_CATEGORIES.PDF,
});
